<template>
  <div v-if="active" @click.stop @keydown.esc.stop="onCancel">
    <b-modal :active.sync="isActive" :has-modal-card="true" :can-cancel="['escape']" :trap-focus="true">
      <div class="modal-card" style="max-width: 450px;">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <p v-html="message"></p>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button class="button" type="button" @click.stop="onCancel">{{ cancelText }}</button>
          <button class="button" type="button" :class="confirmType" @click.stop="onConfirm" :disabled="isConfirming">
            <span v-if="isConfirming" class="icon"><i class="fas fa-spinner fa-spin"></i></span>
            <span>{{ confirmText }}</span>
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    active: { type: Boolean, default: false },
    title: { type: String, default: 'Confirm' },
    message: { type: String, default: 'Are you sure?' },
    confirmText: { type: String, default: 'Confirm' },
    cancelText: { type: String, default: 'Cancel' },
    confirmType: { type: String, default: 'is-danger' },
    isConfirming: { type: Boolean, default: false }
  },
  data () {
    return {
      isActive: this.active
    }
  },
  watch: {
    active (val) {
      this.isActive = val
    },
    isActive (val) {
      if (!val) {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    onConfirm () {
      this.$emit('confirm')
    },
    onCancel () {
      this.isActive = false
      this.$emit('cancel')
    }
  }
}
</script>
